<script lang="ts">
  import {createField} from 'felte';
  import {ValidationMessage} from '@felte/reporter-svelte';

  export let name: string = '';
  export let label: string = '';
  export let subText: string = '';
  export let type: string = '';
  export let placeholder: string = '';
  export let required: boolean = false;
  export let disabled: boolean = false;
  export let newLayout: boolean = true;
  export let isFocused: boolean = false;
  export let autocomplete: string = 'on';
  export let containerClass: string = 'form-group';
  export let id: string = '';
  export let readonly: boolean = false;
  export let value: string = '';
  export let validationMessage: boolean = true;

  const fieldObj = createField(name);
  const {field} = fieldObj;

  $: computedId = id || name;

  const handleInput = e => {
    value = type.match(/^(number|range)$/) ? +e.target.value : e.target.value;
  };
</script>

<div class={containerClass} class:newLayout>
  {#if label}
    <label for={computedId} class={$$props.labelClass} class:newLayout
      >{label}</label
    >
  {/if}
  {#if subText}
    <p>{subText}</p>
  {/if}
  <slot name="input">
    <input
      on:input={handleInput}
      {type}
      id={computedId}
      {name}
      class={`form-control ${$$props.class}`}
      class:is-focused={isFocused}
      use:field
      {placeholder}
      {required}
      {disabled}
      data-testid="input-{name}"
      {autocomplete}
      {readonly}
      {value}
      on:keydown
      on:blur
    />
  </slot>
  <slot name="tooltip" />
  {#if validationMessage}
    <ValidationMessage for={name} let:messages={message}>
      {#if message}
        <div class="error-message" data-testid="error-message-{computedId}">
          {message}
        </div>
      {/if}
    </ValidationMessage>
  {/if}
</div>

<style lang="scss">
  .newLayout {
    & input {
      box-sizing: border-box;
      padding: 0.625rem 0.875rem;
      gap: 0.5rem;
      height: 2.75rem;
      background: #ffffff;
      border: 0.065rem solid #d0d5dd;
      box-shadow: 0 0.065rem 0.125rem rgba(16, 24, 40, 0.05);
      border-radius: 0.25rem;
      flex: none;
      align-self: stretch;
      flex-grow: 0;

      &.form-control {
        width: 100%;
      }

      &.is-focused {
        color: #353331;
        background-color: #fff;
        border-color: #70dbd4;
        box-shadow: inset 0 0.065rem 0.065rem rgb(0 0 0 / 8%),
          0 0 0 0.2rem rgb(41 163 155 / 25%);
      }
    }

    & label {
      font-weight: 500;
      font-size: 0.875rem;
      line-height: 1.25rem;
      color: #344054;
    }

    & .append {
      background: #ffffff;
      box-shadow: 0 0.065rem 0.125rem rgba(16, 24, 40, 0.05);
      height: 2.75rem;
      border-color: #d0d5dd !important;
      padding: 0.675rem 0.75rem !important;
    }

    & .prepared {
      color: #667085 !important;
    }
  }

  .error-message {
    color: #cc5c33;
    margin-top: 0.25rem;
    font-size: 80%;
    width: 100%;
  }
</style>
